import { useLocation, useNavigate } from "react-router-dom";
import { IoHomeOutline, IoHome } from "react-icons/io5";
import { MdOutlineNotificationsNone, MdNotifications } from "react-icons/md";
import { HiOutlineDocumentText, HiDocumentText } from "react-icons/hi";
import { IoPersonOutline, IoPerson } from "react-icons/io5";
import { IoMdAddCircleOutline, IoMdAdd } from "react-icons/io";
import { getUserData } from "@/utils/jwt";

export const TabNavigator = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Detecta o role do usuário
  const userData = getUserData();
  const isAgent = userData?.role === "AGENT";

  const tabs = [
    {
      name: "Início",
      path: "/home",
      icon: IoHomeOutline,
      activeIcon: IoHome,
      hideForAgent: true,
    },
    {
      name: "Ocorrências",
      path: "/ocurrences",
      icon: HiOutlineDocumentText,
      activeIcon: HiDocumentText,
      agentOnly: true,
    },
    {
      name: "Reportar",
      path: "/report",
      icon: IoMdAddCircleOutline,
      activeIcon: IoMdAdd,
      isSpecial: true,
      hideForAgent: true,
    },
    {
      name: "Alertas",
      path: "/alerts",
      icon: MdOutlineNotificationsNone,
      activeIcon: MdNotifications,
    }
  ];

  // Filtra tabs baseado no role
  const visibleTabs = tabs.filter((tab) => {
    if (isAgent && tab.hideForAgent) return false;
    if (!isAgent && tab.agentOnly) return false;
    return true;
  });

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
      <div className="flex items-center justify-around py-2 px-2 md:px-4 max-w-7xl lg:max-w-full mx-auto">
        {visibleTabs.map((tab) => {
          if (tab.isSpecial) {
            return (
              <button
                key={tab.name}
                onClick={() => navigate(tab.path)}
                className="flex flex-col items-center justify-center transition-all group cursor-pointer"
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center shadow-lg transition-all group-hover:shadow-xl group-hover:scale-105 bg-[hsl(var(--primary))]`}
                >
                  {tab.icon && (
                    <tab.icon className="text-white text-2xl md:text-[28px]" />
                  )}
                </div>
                <span
                  className={`text-[9px] md:text-[10px] font-semibold mt-1 transition-colors ${
                    isActive(tab.path)
                      ? "text-[hsl(var(--primary))]"
                      : "text-gray-600"
                  }`}
                >
                  {tab.name}
                </span>
              </button>
            );
          }

          const Icon = isActive(tab.path) ? tab.activeIcon : tab.icon;

          return (
            <button
              key={tab.name}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center py-1.5 md:py-2 px-2 md:px-3 transition-all group hover:scale-105 cursor-pointer"
            >
              <div
                className={`p-1.5 md:p-2 rounded-xl transition-all ${
                  isActive(tab.path)
                    ? "bg-[hsl(var(--primary))]/10"
                    : "group-hover:bg-gray-100"
                }`}
              >
                {Icon && (
                  <Icon
                    className={`text-xl md:text-2xl transition-colors ${
                      isActive(tab.path)
                        ? "text-[hsl(var(--primary))]"
                        : "text-gray-400 group-hover:text-gray-600"
                    }`}
                  />
                )}
              </div>
              <span
                className={`text-[9px] md:text-[10px] font-semibold mt-0.5 md:mt-1 transition-colors ${
                  isActive(tab.path)
                    ? "text-[hsl(var(--primary))]"
                    : "text-gray-600 group-hover:text-gray-800"
                }`}
              >
                {tab.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigator;
